import { useCallback, useState } from 'react';
import { Call } from '@twilio/voice-sdk';
import { Edge, NetworkTestName, TestResults } from '../../types';
import { bitrateTestRunner, dnsLookupTestRunner, preflightTestRunner } from '../Tests/Tests';
import { Region } from '../Tests/Tests.model';

export default function useTestRunner() {
  const [isRunning, setIsRunning] = useState(false);
  const [activeTest, setActiveTest] = useState<NetworkTestName>();
  const [results, setResults] = useState<TestResults>();
  const [activeEdge, setActiveEdge] = useState<Edge>();

  const runTests = useCallback(
    async (
      getVoiceToken: () => Promise<string>,
      getTURNCredentials: () => Promise<RTCIceServer[]>,
      edge: Edge,
      codecPreferences: Call.Codec[],
      region?: Region
    ) => {
      setIsRunning(true);

      const testResults: TestResults | any = {
        edge,
        results: {},
        errors: {},
      };

      setActiveEdge(edge);
      setActiveTest('Preflight Test');

      try {
        const voiceToken = await getVoiceToken();
        const iceServers = await getTURNCredentials();
        testResults.results.preflight = await preflightTestRunner(edge, voiceToken, iceServers, codecPreferences);
      } catch (err) {
        testResults.errors.preflight = err;
      }

      if (!testResults.errors.preflight) {
        setActiveTest('Bitrate Test');
        try {
          const iceServers = await getTURNCredentials();
          testResults.results.bitrate = await bitrateTestRunner(edge, iceServers);
        } catch (err) {
          testResults.errors.bitrate = err;
        }
      }

      try {
        //TODO: DNS lookup tests defaulted to US, will be replaced with logic to determine region.
        const dnsLookupTestResults = await dnsLookupTestRunner(region || Region.US);
        testResults.results.dnsLookupTest = dnsLookupTestResults;
      } catch (err) {
        console.log('Error Performing DNS Lookup Test', err);
        testResults.results.dnsLookupTest = err;
      }

      setResults(testResults);

      setActiveTest(undefined);
      setActiveEdge(undefined);
      setIsRunning(false);
      return testResults;
    },
    []
  );

  return {
    isRunning,
    activeTest,
    results,
    activeEdge,
    runTests,
  };
}
